import * as photoActions from '../actions/documents';

const defaultState = {
    loaded: {
        small: [],
        medium: [],
        large: [],
        original: [],
    },
    loading: {
        small: [],
        medium: [],
        large: [],
        original: [],
    },
    uploaded: {
        cache: {},
    },
};

export default function (state = defaultState, action) {
    switch (action.type) {
        case photoActions.ADD_PHOTO:
            const loaded = {
                ...state.loaded[action.size],
                [action.photoId]: action.url,
            };

            return {
                ...state,
                loaded: {
                    ...state.loaded,
                    [action.size]: loaded,
                },
            };
        case photoActions.ADD_LOADING_PHOTO:
            const loading = state.loading[action.size];
            loading.push(action.photoId);
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.size]: loading,
                },
            };
        case photoActions.REMOVE_LOADING_PHOTO:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.size]: state.loading[action.size].filter(
                        (photoId) => photoId !== action.photoId
                    ),
                },
            };
        case photoActions.ADD_UPLOADED_PHOTO:
            return {
                ...state,
                uploaded: {
                    ...state.uploaded,
                    cache: { [action.photoId]: action.objectSrc },
                },
            };
        case photoActions.CLEAR_UPLOADED_CACHE:
            return {
                ...state,
                uploaded: {
                    uploadedId: null,
                    cache: {},
                },
            };

        default:
            return state;
    }
}
